export const BOOKINGS_APP_DEF_ID = '13d21c63-b5ec-5912-8397-c3a5ddb27a97';
export const SERVICE_LIST_WIDGET_ID = 'cc882051-73c9-41a6-8f90-f6ebc9f10fe1';
export const SERVICE_LIST_PAGE_ID = '621bc837-5943-4c76-a7ce-a0e38185301f';
//# sourceMappingURL=const.js.map